import type { ApisauceInstance } from "apisauce";
import {
  CONTEXTS_LIST_DEFAULT_LIMIT,
  TARS_CONTEXTS_GET_PATH,
  TARS_CONTEXTS_LIST_PATH,
} from "../tars-constants";
import type { ContextListItem } from "./useListContexts";

export interface GetContextResponse {
  id?: number;
  notebook_id?: number;
  context?: string;
  version?: number;
  [key: string]: unknown;
}

function pickLatestContext(
  contexts: ContextListItem[],
  notebookId: number
): GetContextResponse {
  if (contexts.length === 0) {
    return { notebook_id: notebookId, context: "" };
  }
  const latest = contexts.reduce((best, item) =>
    (item.version ?? 0) > (best.version ?? 0) ? item : best
  );
  return latest;
}

export async function fetchNotebookContext(
  api: ApisauceInstance,
  notebookId: number,
  version?: number
): Promise<GetContextResponse> {
  if (version != null) {
    const response = await api.post(TARS_CONTEXTS_GET_PATH, {
      notebook_id: notebookId,
      version,
    });
    if (response.status === 404) {
      return { notebook_id: notebookId, context: "" };
    }
    if (!response.ok) {
      throw new Error(`Failed to fetch context. Status: ${response.status ?? "Unknown"}`);
    }
    return (response.data ?? response) as GetContextResponse;
  }

  const response = await api.post(TARS_CONTEXTS_LIST_PATH, {
    notebook_id: notebookId,
    offset: 0,
    limit: CONTEXTS_LIST_DEFAULT_LIMIT,
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch context. Status: ${response.status ?? "Unknown"}`);
  }
  const data = response.data as { contexts?: ContextListItem[] } | undefined;
  return pickLatestContext(data?.contexts ?? [], notebookId);
}
